import styled from 'vue-styled-components';

import * as C from '../../options/styles';

export const ComponentWrapper = styled(C.ComponentWrapper)`
    .option-title {
        gap: 12px;

        .option-title-text {
            color: var(--color-gray-130);
            font-size: 13px;
            font-weight: 400;
        }
    }
`;

export const ExposureDropdownWrapper = styled.div`
    margin-left: auto;
`;
